import { useState } from "react";
import { Signal, Plus } from "lucide-react";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { uuid } from "@/lib/format";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { BigButton, Chip, Field, inputCls } from "@/components/ui-kit";

export const OPERATORS = [
  { key: "mobilis", name: "Mobilis", color: "#1D9A48", prefix: ["06"] },
  { key: "djezzy", name: "Djezzy", color: "#E3001B", prefix: ["07"] },
  { key: "ooredoo", name: "Ooredoo", color: "#E30613", prefix: ["05"] },
];
const AMOUNTS = [100, 200, 500, 1000, 2000];
export const detectOperator = (phone) => { const p = phone.replace(/\D/g, "").replace(/^213/, "0"); return OPERATORS.find((o) => o.prefix.some((x) => p.startsWith(x)))?.key || ""; };
const validPhone = (phone) => /^0[567]\d{8}$/.test(phone.replace(/\D/g, "").replace(/^213/, "0"));

export default function TopUpDialog({ open, onClose, onAdd }) {
  const { t } = useApp();
  const [op, setOp] = useState("");
  const [phone, setPhone] = useState("");
  const [amount, setAmount] = useState(500);
  const [custom, setCustom] = useState("");
  const onPhone = (v) => { setPhone(v); const d = detectOperator(v); if (d) setOp(d); };
  const value = Number(custom) || amount;
  const add = () => {
    if (!op) return toast.error(t("topup_pick_operator"));
    if (!validPhone(phone)) return toast.error(t("topup_bad_phone"));
    if (!(value > 0)) return toast.error(t("invalid_amount"));
    const o = OPERATORS.find((x) => x.key === op);
    const num = phone.replace(/\D/g, "").replace(/^213/, "0");
    onAdd({ product_id: `topup-${uuid()}`, name: `${t("topup")} ${o.name}`, price: value, cost: value, qty: 1, note: num, topup: { operator: op, phone: num, amount: value } });
    toast.success(`${o.name} · ${num} · ${value}`);
    setPhone(""); setCustom(""); onClose();
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="topup-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Signal className="w-5 h-5 text-[#C0392B]" />{t("topup_title")}</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground">{t("topup_hint")}</p>
        <div className="grid grid-cols-3 gap-2">
          {OPERATORS.map((o) => <button key={o.key} type="button" onClick={() => setOp(o.key)} className={`h-14 rounded-xl font-black text-white text-sm ring-offset-2 ${op === o.key ? "ring-2 ring-[#1A1A1A]" : "opacity-80"}`} style={{ background: o.color }} data-testid={`topup-op-${o.key}`}>{o.name}</button>)}
        </div>
        <Field label={t("topup_phone")}><input dir="ltr" inputMode="tel" value={phone} onChange={(e) => onPhone(e.target.value)} placeholder="06 / 05 / 07 XX XX XX XX" className={`${inputCls} text-lg tracking-wider`} data-testid="topup-phone-input" /></Field>
        <div className="flex flex-wrap gap-1.5">{AMOUNTS.map((a) => <Chip key={a} active={!custom && amount === a} onClick={() => { setAmount(a); setCustom(""); }} data-testid={`topup-amount-${a}`}>{a}</Chip>)}</div>
        <Field label={t("topup_custom")}><input dir="ltr" inputMode="numeric" value={custom} onChange={(e) => setCustom(e.target.value.replace(/\D/g, ""))} placeholder="50 – 5000" className={inputCls} data-testid="topup-custom-input" /></Field>
        <BigButton onClick={add} className="w-full" data-testid="topup-add-btn"><Plus className="w-5 h-5" />{t("add_to_cart")} · {value}</BigButton>
      </DialogContent>
    </Dialog>
  );
}
